import type { PropsWithChildren } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSession } from '../state/session-context'

export function ActivatedRoute({ children }: PropsWithChildren) {
  const { activated } = useSession()
  const location = useLocation()
  return activated ? children : <Navigate to="/activate" replace state={{ from: location.pathname }} />
}
